import './CommentFieldDialog.style.less'
import { Modal, Skeleton } from 'antd'
import AddNewCommentSection from './components/AddNewCommentSection/AddNewCommentSection'
import CommentDisplaySection from './components/CommentDisplaySection/CommentDisplaySection'
import { ICommentDataField } from './CommentFieldDialog.interface'
import { useQuery } from 'react-query'
import { useEffect, useState } from 'react'
import HttpRequest from '@/config/axios.config'
import socket from '@/utils/socket'
import { isEmptyValue, onComment } from '@/utils/common'

let datas: any = []

function CommentFieldDialog(props: {
  visible: boolean
  label: string
  taskId: string
  data: any
  onClose: () => any
}) {
  const { visible, label, taskId, onClose, data: task } = props
  const [requestAPI, setRequestAPI]: any = useState(true)
  const { isLoading, data, refetch } = useQuery(
    ['commentQuery', props.taskId],
    async () => {
      let response = null
      // if (requestAPI) {
      response = await HttpRequest.get(`comments/tasks/${taskId}`)
      // setRequestAPI(false)
      // }
      // if (!response) return datas
      return response
    }
  )

  datas = data

  ///Join room with tasks ID for socket comment to work///
  useEffect(() => {
    if (!isEmptyValue(data)) {
      socket.emit('join', `comment_${props.data?.id}`)
    }
    return () => {
      socket.emit('leave', `comment_${props.data?.id}`)
    }
  }, [data])

  ///For refetching comment using socket///
  useEffect(() => {
    setTimeout(() => {
      if (socket) {
        socket.on('comment', () => {
          refetch()
        })
      }
    }, 1000)
    return () => {
      socket.off('comment', () => {
        refetch()
      })
    }
  }, [socket.emit('join', `comment_${props.data?.id}`).connected])

  return (
    <div>
      <Modal
        title={<div className="dialog-header py-2">{`Comment - ${label}`}</div>}
        open={visible}
        onCancel={onClose}
        footer={null}
        width={660}
        className={'dialog-set-plan'}
      >
        <div className="wrap-comments">
          <div className="row">
            <div className="col-12">
              {isLoading && <Skeleton active />}
              {data?.data?.data &&
                data?.data?.data.map((comment: ICommentDataField, index) => {
                  if (comment.type === 'reply') return <></>
                  return (
                    <div key={`${index}-${comment?.id}`}>
                      <CommentDisplaySection
                        onReload={refetch}
                        section={'byOrderId'}
                        data={comment}
                        task={data}
                        taskId={taskId}
                      />
                    </div>
                  )
                })}
              <AddNewCommentSection comment={data} data={task} />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default CommentFieldDialog
